import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { editUserRemarkApi } from "@/service/modules/user";
export default /*#__PURE__*/_defineComponent({
  __name: 'remake-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const emit = __emit;
    const subBtnLoading = ref(false);
    const props = __props;
    const formRef = ref();
    const rules = {
      desc: [{
        required: true,
        message: "请输入备注信息",
        trigger: "blur"
      }]
    };
    function closeDialog() {
      formRef.value?.resetFields();
      emit("closeDialog");
    }
    const form = reactive({
      id: "",
      desc: ""
    });
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      const res = await editUserRemarkApi(form);
      emit("restData");
      subBtnLoading.value = false;
    }
    const init = () => {
      form.id = props.itemData.id;
      form.desc = props.itemData.desc;
    };
    init();
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: "备注信息",
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[2] || (_cache[2] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "desc"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.desc,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.desc = $event),
              type: "textarea",
              rows: "5",
              placeholder: "请输入备注信息"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value"])]);
    };
  }
});